import type { ChromeStrings } from './en';

/** Arabic chrome strings (RTL). Mirrors the EN catalog keys. */
const ar: ChromeStrings = {
  app: {
    title: 'لوحة فاراديف',
    edition: 'مواقع وبرمجيات أعمال ثنائية اللغة',
    primaryNav: 'التنقل الرئيسي',
    toggleNav: 'تبديل قائمة التنقل',
    version: 'الإصدار',
  },
  nav: {
    dashboard: 'لوحة المعلومات',
    content: 'المحتوى',
    pages: 'الصفحات',
    fieldNotes: 'المدونة',
    services: 'الخدمات',
    caseStudies: 'دراسات الحالة',
    packages: 'الباقات',
    clients: 'العملاء',
    testimonials: 'الشهادات',
    productFamilies: 'عائلات المنتجات',
    industries: 'القطاعات',
    projects: 'المشاريع',
    articles: 'المقالات',
    jobPostings: 'الوظائف',
    products: 'المنتجات',
    locations: 'المواقع',
    subsidiaries: 'الشركات التابعة',
    siteAssets: 'أصول الموقع',
    teamMembers: 'أعضاء الفريق',
    media: 'مكتبة الوسائط',
    leads: 'العملاء المحتملون',
    contact: 'مكالمات استكشافية',
    quotes: 'طلبات عروض الأسعار',
    applications: 'طلبات التوظيف',
    newsletter: 'النشرة البريدية',
    revisions: 'المراجعات',
    administration: 'الإدارة',
    users: 'المستخدمون',
    apiTokens: 'رموز الـ API',
    settings: 'إعدادات الموقع',
    audit: 'سجل التدقيق',
    search: 'بحث',
    account: 'الحساب',
    signOut: 'تسجيل الخروج',
  },
  common: {
    save: 'حفظ',
    saveDraft: 'حفظ كمسودة',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    create: 'إنشاء',
    confirm: 'تأكيد',
    ok: 'حسنًا',
    retry: 'إعادة المحاولة',
    reset: 'إعادة تعيين',
    publish: 'نشر',
    unpublish: 'إلغاء النشر',
    schedule: 'جدولة',
    preview: 'معاينة',
    status: 'الحالة',
    title: 'العنوان',
    slug: 'المعرف',
    key: 'المفتاح',
    namespaces: 'النطاقات',
    updated: 'آخر تحديث',
    created: 'تاريخ الإنشاء',
    actions: 'إجراءات',
    loading: 'جارٍ التحميل',
    search: 'بحث',
    filters: 'عوامل التصفية',
    clear: 'مسح',
    copy: 'نسخ',
    all: 'الكل',
    none: 'لا شيء',
    en: 'الإنجليزية',
    ar: 'العربية',
    lastSaved: 'آخر حفظ {{time}}',
    siteWillUpdate: 'تم الحفظ. سيتم تحديث الموقع العام قريبًا.',
    permissionDenied: 'ليس لديك إذن للقيام بذلك.',
    missingArabic: 'العربية غير مكتملة',
    arComplete: 'العربية مكتملة',
  },
  auth: {
    signIn: 'تسجيل الدخول',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    totp: 'رمز المصادقة',
    totpHint: 'أدخل الرمز المكون من 6 أرقام من تطبيق المصادقة.',
    forgot: 'هل نسيت كلمة المرور؟',
    forgotTitle: 'إعادة تعيين كلمة المرور',
    forgotNeutral: 'إذا كان هناك حساب بهذا البريد، فستتلقى تعليمات إعادة التعيين.',
    resetTitle: 'اختر كلمة مرور جديدة',
    newPassword: 'كلمة المرور الجديدة',
    locked: 'هذا الحساب مقفل مؤقتًا. حاول مرة أخرى لاحقًا.',
    rateLimited: 'محاولات كثيرة جدًا. يرجى الانتظار قليلًا ثم المحاولة مرة أخرى.',
    invalid: 'البريد الإلكتروني أو كلمة المرور غير صحيحة.',
    invalidTotp: 'رمز المصادقة غير صحيح. حاول مرة أخرى.',
    totpRequired: 'أدخل الرمز المكوّن من 6 أرقام من تطبيق المصادقة للمتابعة.',
    eyebrowSignIn: 'المسؤول · تسجيل الدخول',
    eyebrowReset: 'المسؤول · إعادة التعيين',
    sendResetLink: 'إرسال رابط إعادة التعيين',
    resetInvalid: 'رابط إعادة التعيين غير صالح أو منتهي الصلاحية. اطلب رابطًا جديدًا.',
    setNewPassword: 'تعيين كلمة مرور جديدة',
  },
  ui: {
    nothingHereYet: 'لا يوجد شيء هنا بعد',
    noResults: 'لا توجد نتائج',
    somethingWentWrong: 'حدث خطأ ما.',
    error: 'خطأ',
    reportThis: 'الإبلاغ عن ذلك',
    readOnlyAccess: 'لديك صلاحية الاطلاع فقط على هذا القسم.',
    paginationSummary: '<from>{{from}}</from>–<to>{{to}}</to> من <total>{{total}}</total>',
    perPage: 'لكل صفحة',
    prev: 'السابق',
    next: 'التالي',
    previousPage: 'الصفحة السابقة',
    nextPage: 'الصفحة التالية',
    close: 'إغلاق',
    typeToConfirm: 'اكتب "{{phrase}}" للتأكيد',
    selectPlaceholder: 'اختر…',
    selectAllRows: 'تحديد كل الصفوف',
    selectRow: 'تحديد الصف {{id}}',
    crashTitle: 'حدثت مشكلة في هذا العرض',
    crashBody: 'لم تتأثر بقية لوحة التحكم. حاول مرة أخرى أو أعد تحميل الصفحة.',
    reload: 'إعادة التحميل',
  },
  status: {
    content: {
      draft: 'مسودة',
      in_review: 'قيد المراجعة',
      scheduled: 'مجدول',
      published: 'منشور',
      archived: 'مؤرشف',
    },
    lead: {
      new: 'جديد',
      in_progress: 'قيد المعالجة',
      reviewing: 'قيد المراجعة',
      shortlisted: 'في القائمة المختصرة',
      responded: 'تم الرد',
      hired: 'تم التوظيف',
      rejected: 'مرفوض',
      closed: 'مغلق',
      spam: 'بريد مزعج',
      archived: 'مؤرشف',
    },
    newsletter: {
      confirmed: 'مؤكد',
      pending_confirmation: 'بانتظار التأكيد',
      unsubscribed: 'ملغى الاشتراك',
    },
  },
  forms: {
    remove: 'إزالة',
    addItem: '+ إضافة عنصر',
    addEntry: '+ إضافة مُدخل',
    mapKey: 'المفتاح',
    mapValue: 'القيمة',
    mapKeyDuplicate: 'مفتاح مكرر',
    item: 'العنصر {{n}}',
    indexLabel: '#{{n}}',
    rawHint: 'احتياطي بصيغة JSON الخام. يتم التحقق منه عند الحفظ.',
    rawLabel: '{{name}} (خام)',
    choose: 'اختيار',
    noMediaSelected: 'لم يتم اختيار وسائط',
    noEntitySelected: 'لم يتم اختيار مرجع {{collection}}',
    fieldEnglish: '{{label}} (الإنجليزية)',
    fieldArabic: '{{label}} (العربية)',
    refNone: 'لم يتم الاختيار',
    refMissing: '{{value}} (غير موجود)',
    noFields: 'لا توجد حقول قابلة للتهيئة.',
  },
  governance: {
    arCoverage: 'تغطية اللغة العربية',
    noTranslatableFields: 'لا يوجد نص قابل للترجمة بعد',
    coverageCount: '{{translated}} / {{total}} مترجَم',
    arabicComplete: 'الترجمة العربية مكتملة',
    arabicCompleteHintReady: 'جميع الحقول القابلة للترجمة تحتوي على نص عربي.',
    arabicCompleteHintPending: '{{count}} حقل/حقول ما زالت بدون ترجمة عربية.',
    arabicCompleteGate: 'حتى يتم تفعيل هذا، قد يُمنع النشر لتجنّب عرض صفحة نصفها مترجَم.',
    publishBlockedAr: 'تعذّر النشر: المحتوى العربي غير مكتمل.',
    publishBlockedArDetail: 'أكمل الترجمة العربية وفعّل "الترجمة العربية مكتملة"، ثم انشر.',
  },
  vocab: {
    block: {
      paragraph: 'فقرة',
      subheading: 'عنوان فرعي',
      list: 'قائمة',
      pullquote: 'اقتباس مميّز',
      aside: 'حاشية',
      figure: 'صورة',
    },
    packageCategory: {
      none: 'بلا منتج (الإضافات وخطط الرعاية)',
      website: 'موقع إلكتروني',
      app: 'تطبيق',
      service: 'خدمة',
    },
    packageKind: {
      project: 'مشروع',
      addon: 'إضافة',
      care: 'خطة رعاية',
      audit: 'تدقيق',
    },
    priceUnit: {
      project: 'لكل مشروع',
      month: 'شهرياً',
      each: 'لكل وحدة',
      percent: 'نسبة من سعر المشروع',
    },
    estimatorRole: {
      none: 'خارج حاسبة التقدير',
      integration: 'التكاملات (عدد)',
      mobileApp: 'تطبيق جوال',
      inheritedCode: 'كود كتبه فريق آخر',
      liveReplacement: 'استبدال موقع قائم',
    },
    clientType: {
      external: 'خارجي',
      group: 'علامة المجموعة',
    },
    department: {
      leadership: 'القيادة',
      marketing: 'التسويق',
      engineering: 'الهندسة',
    },
    topic: {
      automation: 'الأتمتة',
      digitalTransformation: 'التحول الرقمي',
      ai: 'الذكاء الاصطناعي',
      customSoftware: 'البرمجيات المخصصة',
      integration: 'تكامل الأنظمة',
      security: 'الأمن السيبراني',
    },
    icon: {
      zap: 'ومضة',
      code: 'شيفرة',
      puzzle: 'أحجية',
      brain: 'دماغ',
      shield: 'درع',
      clipboardCheck: 'قائمة تحقّق',
      search: 'بحث',
    },
    industry: {
      restaurant: 'مطاعم',
      mobile: 'تطبيقات الجوال',
      aiSaas: 'برمجيات الذكاء الاصطناعي',
      publishing: 'النشر',
      industrial: 'صناعي',
      education: 'تعليم',
    },
    device: {
      laptop: 'حاسوب محمول',
      phone: 'هاتف',
    },
    kind: {
      product: 'منتج',
      client: 'عمل لعميل',
    },
    serviceTier: {
      core: 'خدمة أساسية',
      additional: 'متاحة أيضاً',
    },
  },
  dashboard: {
    eyebrow: 'لوحة التحكم',
    title: 'نظرة تشغيلية عامة',
    pages: 'الصفحات',
    contentByCollection: 'المحتوى حسب المجموعة',
    leads: 'العملاء المحتملون',
    agentActivity: 'نشاط الوكلاء الأخير',
    agentActivityHint:
      'عمليات كتابة تمت عبر رمز API. كل ما ينشئه الوكيل يبقى مسودة؛ راجعه قبل النشر.',
    agentActivityLink: 'فتح سجل التدقيق الكامل',
    agentActor: 'رمز API',
    recentActivity: 'النشاط الأخير',
    total: 'الإجمالي',
    published: 'منشور',
    draft: 'مسودة',
    media: 'الوسائط',
    newCount: '{{count}} جديد',
    ofPublished: '/ {{total}} منشور',
    totalSuffix: 'الإجمالي',
    systemActor: 'النظام',
  },
  activity: {
    action: {
      login: 'سجّل الدخول',
      logout: 'سجّل الخروج',
      create: 'أنشأ',
      update: 'حدّث',
      delete: 'حذف',
      publish: 'نشر',
      unpublish: 'ألغى النشر',
    },
    entity: {
      user: 'مستخدم',
      page: 'صفحة',
      section: 'قسم',
      family: 'عائلة منتجات',
      product_family: 'عائلة منتجات',
      media: 'ملف وسائط',
      industry: 'قطاع',
      project: 'مشروع',
      article: 'مقال',
      job: 'وظيفة شاغرة',
      product: 'منتج',
      location: 'موقع',
      subsidiary: 'شركة تابعة',
      setting: 'إعداد',
    },
  },
  content: {
    unknownCollection: 'مجموعة غير معروفة.',
    newItem: 'عنصر جديد',
    newItemPermission: 'يتطلب صلاحية لإنشاء المحتوى أو تعديله.',
    order: 'الترتيب',
    arShort: 'ع',
    missingAr: 'العربية ناقصة',
    selected: 'محدد',
    publishPermission: 'يتطلب صلاحية النشر.',
    deletePermission: 'يتطلب صلاحية الحذف.',
    bulkResult: '{{action}}: نجح {{succeeded}}، وفشل {{failed}}.',
    bulkPartialFail: 'تعذّرت معالجة بعض العناصر. عدّل المعطيات وأعد المحاولة.',
    statusFilter: {
      all: 'كل الحالات',
      draft: 'مسودة',
      scheduled: 'مجدول',
      published: 'منشور',
      archived: 'مؤرشف',
    },
    newTitle: '{{label}} جديد',
    untitled: '(بدون عنوان)',
    editPermission: 'يتطلب صلاحية لتعديل المحتوى.',
    slugHint: 'يُولَّد تلقائيًا من العنوان الإنجليزي؛ يمكنك تعديله لتجاوزه.',
    sortOrder: 'ترتيب الفرز',
    sortOrderHint: 'الرقم الأصغر يظهر أولًا. يحدّد الترتيب على الموقع وفي هذه القائمة.',
    contentTab: 'المحتوى',
    seoTab: 'تحسين محركات البحث',
    historyTab: 'السجل',
    createdToast: 'تم الإنشاء.',
    savedToast: 'تم الحفظ.',
    siteUpdateBody: 'سيتم تحديث الموقع العام قريبًا.',
    publicationUpdated: 'تم تحديث النشر.',
    unpublishedToast: 'تم إلغاء النشر.',
    unpublishRedirect: 'تُعيد الصفحة العامة الآن التوجيه إلى فهرس المجموعة.',
    filterAll: 'الكل',
    choose: 'اختر {{label}}',
    deleteItemTitle: 'حذف هذا العنصر؟',
    deleteItemDescription: 'سيُحذف هذا العنصر نهائيًا. لا يمكن التراجع عن هذا الإجراء.',
  },
  collections: {
    fieldNotes: { label: 'المدونة', singular: 'مقال' },
    services: { label: 'الخدمات', singular: 'خدمة' },
    caseStudies: { label: 'دراسات الحالة', singular: 'دراسة حالة' },
    packages: { label: 'الباقات', singular: 'باقة' },
    clients: { label: 'العملاء', singular: 'عميل' },
    testimonials: { label: 'الشهادات', singular: 'شهادة' },
    industries: { label: 'القطاعات', singular: 'قطاع' },
    projects: { label: 'المشاريع', singular: 'مشروع' },
    articles: { label: 'المقالات / الرؤى', singular: 'مقال' },
    jobPostings: { label: 'الوظائف الشاغرة', singular: 'وظيفة شاغرة' },
    products: { label: 'المنتجات', singular: 'منتج' },
    locations: { label: 'المواقع', singular: 'موقع' },
    subsidiaries: { label: 'الشركات التابعة', singular: 'شركة تابعة' },
    siteAssets: { label: 'أصول الموقع', singular: 'أصل الموقع' },
    teamMembers: { label: 'الفريق', singular: 'عضو الفريق' },
  },
  fields: {
    // ── الملاحظات الميدانية (مجموعة فاراديف للمدونة/الرؤى) ──
    fieldNoteContent: 'ملاحظة ميدانية',
    fieldNoteCategoryHint: 'سطر علوي قصير فوق العنوان، مثل «في المنهج» أو «ملاحظة ميدانية».',
    excerptHint: 'جملة تشويقية واحدة تظهر في فهرس المدونة وفي معاينات المشاركة.',
    readingTime: 'وقت القراءة',
    readingTimeHint: 'يظهر على البطاقة والمقال، مثل «٦ دقائق».',
    displayDate: 'التاريخ المعروض',
    displayDateHint: 'تاريخ يُعرض للقرّاء، مثل «مارس 2026».',
    dateIso: 'التاريخ الآلي',
    dateIsoHint: 'تاريخ ISO للفرز والبيانات الوصفية، مثل 2026-03-14.',
    fieldNoteFeaturedHint: 'إبراز هذه الملاحظة في الفهرس وتشويقة الصفحة الرئيسية.',
    heroSrc: 'مسار الصورة',
    heroSrcHint: 'مسار أو رابط الصورة الرئيسية (يوفّر المحرّر المباشر منتقي وسائط).',
    width: 'العرض',
    height: 'الارتفاع',
    question: 'السؤال الافتتاحي',
    questionHint: 'السؤال الذي تفتتح به الملاحظة — صوت فاراديف.',
    lede: 'المقدّمة',
    ledeHint: 'الفقرة الاستهلالية أسفل السؤال.',
    authorName: 'اسم الكاتب',
    authorRole: 'صفة الكاتب',
    bodyBlock: 'كتلة',
    blockType: 'النوع',
    blockText: 'النص',
    blockTextHint: 'تستخدمه كتل الفقرة والعنوان الفرعي والاقتباس والحاشية.',
    blockItems: 'عناصر القائمة',
    blockAttribution: 'النسبة',
    blockAttributionHint: 'الجهة المنسوب إليها الاقتباس المميّز.',
    blockCaption: 'التعليق التوضيحي',
    bodyHint: 'متن المقال ككتل مرتّبة، يُحرَّر لكل لغة.',
    bodyEn: 'المتن (الإنجليزية)',
    bodyAr: 'المتن (العربية)',
    ctaPromise: 'الوعد',
    ctaSecondary: 'الزر الثانوي',
    ctaMarginNote: 'ملاحظة الهامش',
    finalCta: 'الدعوة الختامية',
    finalCtaHint: 'الدعوة الختامية لاتخاذ إجراء، وهي الخطوة التالية الوحيدة للملاحظة.',
    finalCtaEn: 'الدعوة الختامية (الإنجليزية)',
    finalCtaAr: 'الدعوة الختامية (العربية)',
    topic: 'الموضوع',
    topicHint: 'وسم موضوع اختياري يستخدمه مرشّح فهرس المدونة.',
    // ── مجموعات إعادة الهيكلة 2026 ───────────────────────────────────────
    serviceContent: 'خدمة',
    caseStudyContent: 'دراسة حالة',
    packageContent: 'باقة',
    clientContent: 'عميل',
    testimonialContent: 'شهادة',
    layer: 'الطبقة',
    layerHint: 'موضع هذه الخدمة في العرض — خدمة أساسية أو إضافية.',
    order: 'الترتيب',
    clientType: 'نوع العميل',
    typeLabel: 'تسمية النوع',
    context: 'السياق',
    challenge: 'التحدي',
    solution: 'الحل',
    deliverables: 'المخرجات',
    results: 'النتائج',
    resultPlaceholder: 'النتائج مؤقتة',
    idealFor: 'مناسب لـ',
    inclusions: 'ما تشمله',
    investment: 'الاستثمار',
    recommended: 'موصى به',
    packageKind: 'نوع البند',
    packageKindHint: 'المشاريع والتدقيق (الخدمات) هي نقاط انطلاق حاسبة التقدير، والإضافات تغيّر سعر المشروع، وخطط الرعاية شهرية.',
    packageCategory: 'المنتج',
    packageCategoryHint: 'المنتج الذي تظهر تحته هذه الباقة في صفحة الأسعار. حدّده للمشاريع والتدقيق، واتركه فارغاً للإضافات وخطط الرعاية.',
    priceFrom: 'السعر من (دولار)',
    priceFromHint: 'بالدولار دون كسور، ويظهر في صفحة الأسعار بصيغة «من». للوحدة النسبية: أقل نسبة.',
    priceTo: 'السعر إلى (دولار)',
    priceToHint: 'اتركه فارغاً إن لم يكن له حد أعلى («من ١٢٬٠٠٠ دولار»). تُسعَّر الطلبات على هذه الأرقام نفسها.',
    priceUnit: 'وحدة التسعير',
    investmentHint: 'يظهر تحت السعر، مثل «سعر ثابت، ونصفه مقدّماً».',
    timeline: 'المدة',
    recommendedHint: 'يبرز البند. اختر بنداً واحداً على الأكثر لكل نوع.',
    estimator: 'حاسبة التقدير',
    estimatorHint: 'المشاريع: قواعد الصفحات واللغة. الإضافات: أي عنصر في الحاسبة يسعّره هذا البند.',
    estimatorRole: 'عنصر الحاسبة',
    pagesIncluded: 'الصفحات المشمولة',
    pagesMax: 'أقصى عدد صفحات مسعّرة',
    extraPagePrice: 'سعر الصفحة الإضافية (دولار)',
    bilingualIncluded: 'العربية والإنجليزية مشمولتان',
    bilingualUpliftPct: 'زيادة اللغة الثانية (٪)',
    mobileIncluded: 'هذه الباقة هي تطبيق الجوال',
    mobileIncludedHint: 'لا تُعرض إضافة تطبيق الجوال ولا تُحتسب فوقها.',
    ctaLabelField: 'نص الزر',
    website: 'الموقع الإلكتروني',
    caseStudySlug: 'معرّف دراسة الحالة',
    role: 'الدور',
    note: 'ملاحظة',
    open: 'وظيفة شاغرة',
    quote: 'الاقتباس',
    company: 'الشركة',
    placeholder: 'عنصر نائب',
    testimonial: 'شهادة',
    industry: 'القطاع',
    country: 'الدولة',
    featured: 'مميَّز',
    category: 'التصنيف',
    department: 'القسم',
    graduate: 'خريج',
    family: 'العائلة',
    kind: 'النوع',
    industryContent: 'محتوى القطاع',
    projectContent: 'محتوى المشروع',
    articleContent: 'محتوى المقالة',
    jobPostingContent: 'محتوى الوظيفة الشاغرة',
    productContent: 'محتوى المنتج',
    locationContent: 'محتوى الموقع',
    isHq: 'المقر الرئيسي',
    isHqHint: 'يحدد هذا الموقع كمقر رئيسي — تُبرز بطاقته في صفحة التواصل.',
    locationTag: 'الوسم',
    locationTagHint: 'سطر علوي قصير فوق اسم المدينة، مثل «المقر الرئيسي · التصنيع».',
    address: 'العنوان',
    areaSqm: 'المساحة',
    areaSqmHint: 'اختياري، يظهر كشارة، مثل «36,000 م²».',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    hours: 'ساعات العمل',
    here: 'ما يوجد هنا',
    hereHint: 'وصف موجز للوظائف الموجودة في هذا المكتب.',
    subsidiaryContent: 'محتوى الشركة التابعة',
    subsidiaryTier: 'الفئة',
    subsidiaryTierHint: 'كيفية عرض هذا الكيان على الموقع: العلامة الأم، أو الشركة الرائدة في المملكة، أو شركة تابعة متخصّصة.',
    founded: 'سنة التأسيس',
    foundedHint: 'سنة التأسيس، مثل 2009.',
    subsidiaryInvestors: 'نص صفحة المستثمرين',
    subsidiaryAbout: 'نص صفحة من نحن',
    subsidiaryName: 'الاسم المعروض',
    subsidiaryFunction: 'الوظيفة',
    subsidiaryCategory: 'التصنيف',
    subsidiaryMeta: 'سطر التفاصيل',
    subsidiaryBody: 'النص',
    siteAssetContent: 'أصل الموقع',
    image: 'الصورة',
    imageHint: 'الصورة المعروضة لهذا العنصر على الموقع. استبدل الصورة المؤقتة برفع صورة حقيقية.',
    altText: 'النص البديل',
    teamMemberContent: 'عضو الفريق',
    teamGroup: 'المجموعة',
    teamGroupHint: 'موضع ظهور الشخص في صفحة من نحن: سجل مجلس الإدارة، أو بطاقة الرئيس التنفيذي، أو شريط الفريق التنفيذي.',
    teamRole: 'المنصب',
    teamRoleHint: 'المنصب أو اللقب، مثل رئيس مجلس الإدارة أو عضو مجلس الإدارة أو العمليات.',
    teamMeta: 'سطر التفاصيل',
    teamMetaHint: 'ملاحظة اختيارية تظهر أسفل الرئيس التنفيذي، مثل: عُيّن رئيساً تنفيذياً للمجموعة 2023.',
    teamBio: 'نبذة',
    teamBioHint: 'تظهر لمجلس الإدارة والرئيس التنفيذي. افصل الفقرات بسطر فارغ.',
    teamPoints: 'أبرز النقاط',
    teamPointsHint: 'نقاط موجزة تظهر لأعضاء الفريق التنفيذي.',
    teamPhoto: 'الصورة الشخصية',
    teamPhotoHint: 'صورة اختيارية. عند تركها فارغة يعرض الموقع الأحرف الأولى من الاسم.',
    teamEmail: 'البريد الإلكتروني',
    teamLinkedin: 'رابط لينكدإن',
    copy: 'النص',
    heroImage: 'الصورة الرئيسية',
    year: 'السنة',
    categoryKey: 'التصنيف',
    datasheet: 'ورقة البيانات',
    coordinates: 'الإحداثيات',
    coordinatesHint: 'انقر على الخريطة لتحديد موقع المكتب، أو أدخل خط العرض/الطول (مثلاً من خرائط جوجل). يُستخدم لتحديد موقع المكتب على خريطة المملكة العامة.',
    latitude: 'خط العرض',
    longitude: 'خط الطول',
    links: 'الروابط',
    icon: 'الأيقونة',
    iconHint: 'اختر أيقونة من مجموعة العلامة التجارية لهذا القطاع. اتركها فارغة لاستخدام صورة مخصّصة (أدناه) أو الأيقونة الافتراضية.',
    customIcon: 'أيقونة مخصّصة',
    customIconHint: 'اختياري. ارفع صورة لتجاوز قائمة الأيقونات — يُفضّل ملف SVG بسيط بلون واحد ليتناسب مع أيقونات العلامة التجارية.',
    summary: 'الملخّص',
    description: 'الوصف',
    client: 'العميل',
    confidential: 'سرّي',
    confidentialHint:
      'عند التفعيل، يُخفى اسم العميل من الموقع العام؛ ويظل المشروع ظاهراً مع وسم "سرّي".',
    location: 'الموقع',
    shortDescription: 'وصف مختصر',
    relatedProjects: 'المشاريع ذات الصلة',
    relatedProjectsHint: 'المشاريع المعروضة بجانب هذا القطاع في الموقع العام.',
    project: 'مشروع',
    industryHint: 'يصنّف هذا المشروع تحت قطاع في الموقع العام. اختر من قطاعاتك.',
    scope: 'نطاق العمل',
    outcome: 'النتيجة',
    caseDiagram: 'مخطط الحالة',
    caseDiagramHint: 'مخطط أحادي الخط اختياري لدراسة الحالة المميَّزة.',
    flag: 'وسم تحريري',
    flagHint: 'شارة اختيارية تظهر على بطاقة المقالة.',
    readMinutes: 'وقت القراءة (دقائق)',
    publishedAt: 'تاريخ النشر',
    publishedAtHint: 'التاريخ المعروض، مثل 2024-01-10. يختلف عن إجراء النشر في النظام.',
    excerpt: 'مقتطف',
    deck: 'المقدّمة',
    deckHint: 'النص التمهيدي الذي يظهر أسفل العنوان في البطاقة وصفحة المقال.',
    topicTag: 'وسم الموضوع',
    topicTagHint: 'وسم قصير يظهر على البطاقة، مثل «الشبكة الذكية · رؤية 2030».',
    author: 'الكاتب',
    body: 'النص الكامل',
    mark: 'العلامة / الصورة المصغّرة',
    employmentType: 'نوع التوظيف',
    brief: 'نبذة',
    experience: 'الخبرة',
    jobDescription: 'الوصف',
    overview: 'نظرة عامة',
    responsibilities: 'المسؤوليات',
    requirements: 'المتطلبات',
    howToApply: 'كيفية التقديم',
    familyHint: 'العائلة التي ينتمي إليها هذا المنتج. تحدّد الرابط الذي يصفّي عليه الموقع العام.',
    tag: 'وسم',
    spec: 'سطر المواصفات',
    badge: 'شارة',
    badgeHint: 'علامة تحريرية اختيارية على بطاقة المنتج (اتركها فارغة لإخفائها).',
    badgeLabel: 'نص الشارة',
    badgeTone: 'لون الشارة',
    thumbnail: 'صورة مصغّرة',
    thumbnailHint: 'صورة البطاقة. اتركها فارغة للإبقاء على الرسم المرفق لمنتجات الإطلاق.',
    specs: 'المواصفات',
    specLabel: 'اسم المواصفة',
    specValue: 'قيمة المواصفة',
    specUnit: 'الوحدة',
    variants: 'الإصدارات / المدى',
    variantName: 'الاسم',
    variantSpec: 'المواصفة',
    variantNote: 'ملاحظة',
    highlights: 'أبرز النقاط',
    hero: 'القسم الرئيسي',
    heroHeadline: 'العنوان الرئيسي',
    heroSupporting: 'النص الداعم',
    stats: 'إحصاءات رئيسية',
    statValue: 'القيمة',
    statSuffix: 'الوحدة / اللاحقة',
    statLabel: 'التسمية',
    standardsHint: 'معيار واحد في كل سطر، مثل IEC 61439.',
    cta: 'دعوة لاتخاذ إجراء',
    ctaHeading: 'العنوان',
    ctaBody: 'النص',
    ctaPrimary: 'الزر الأساسي',
    ctaLabel: 'نص الزر',
    ctaHref: 'رابط الزر',
    // ── مزامنة المرحلة 3: الخدمات ودراسات الحالة والعملاء والفريق والشهادات ──
    updatedIso: 'تاريخ آخر تحديث',
    updatedIsoHint: 'تاريخ ISO اختياري يظهر كبيانات "محدَّث"، مثل 2026-05-02.',
    shortTitle: 'عنوان مختصر',
    shortTitleHint: 'تسمية موجزة تُستخدم على بطاقة الخدمة وواجهة الصفحة الرئيسية.',
    serviceIconHint: 'اختر أيقونة Lucide التي تظهر على بطاقة هذه الخدمة.',
    serviceTier: 'الفئة',
    serviceTierHint: 'تُعرض الخدمات الأساسية كاملةً في صفحة الخدمات والصفحة الرئيسية، وتظهر الخدمات «المتاحة أيضاً» في مجموعة مختصرة. تبقى صفحاتها منشورة في الحالتين.',
    features: 'المزايا',
    featuresHint: 'قائمة نطاق العمل التي تظهر في صفحة تفاصيل الخدمة — سطر لكل عنصر.',
    benefits: 'الفوائد',
    benefitsHint: 'بطاقات مؤشرات في صفحة التفاصيل: رمز عرضي مع تسمية مُترجمة.',
    metric: 'المؤشر',
    metricHint: 'رمز عرضي قصير، ثابت في كل لغة، مثل "80%" أو "3x".',
    label: 'التسمية',
    faq: 'الأسئلة الشائعة',
    faqQuestion: 'السؤال',
    faqAnswer: 'الإجابة',
    serviceHeroHint: 'صورة رئيسية اختيارية لصفحة تفاصيل الخدمة.',
    builtFor: 'أُنجز لصالح',
    industryKey: 'القطاع (مفتاح التصفية)',
    industryKeyHint: 'المفتاح المعتمد الذي يصفّي عليه معرض الأعمال العام. التسمية أعلاه للعرض فقط.',
    kindHint: 'يقسّم معرض الأعمال إلى منتجات Pharadev وأعمال العملاء — تصفية عامة.',
    device: 'إطار الجهاز',
    deviceHint: 'إطار الجهاز المستخدم في صورة البطاقة.',
    serviceSlugs: 'الخدمات ذات الصلة',
    serviceSlugsHint: 'الخدمات المُنجزة في هذا المشروع. يرتبط كل عنصر بخدمة عبر المُعرّف.',
    service: 'الخدمة',
    tech: 'التقنيات',
    techHint: 'التقنيات المستخدمة، واحدة في كل سطر.',
    caseFeaturedHint:
      'الدراسات المميَّزة تظهر في شريط العرض الرئيسي بالصفحة الرئيسية — أول 5 حسب ترتيب الفرز، لذا إبراز دراسة سادسة لا يغيّر شيئًا هناك. كما تضع شعار «مميَّز» في فهرس الأعمال وتحدّد الدراسة المبرَزة في الصفحة الرئيسية.',
    logo: 'الشعار',
    thumbnailEn: 'الصورة المصغّرة (الإنجليزية)',
    thumbnailEnHint: 'صورة البطاقة في فهرس الأعمال الإنجليزي.',
    thumbnailAr: 'الصورة المصغّرة (العربية)',
    thumbnailArHint: 'صورة البطاقة في فهرس الأعمال العربي.',
    liveUrl: 'الرابط المباشر',
    liveUrlHint: 'رابط اختياري للمنتج أو المشروع المباشر.',
    gallery: 'المعرض',
    galleryHint: 'اللقطات المعروضة في صفحة دراسة الحالة، مع تعليق اختياري لكل منها.',
    galleryImage: 'الصورة',
    galleryCaption: 'التعليق',
    caseStudySlugHint: 'اربط هذا العنصر اختياريًا بدراسة الحالة الخاصة به.',
    teamNoteHint: 'سطر قصير اختياري يظهر تحت الاسم، مثل مجال التركيز.',
    openHint: 'يشير إلى وظيفة شاغرة — يعرض الموقع أحرفًا أولية بدل الصورة.',
    linkedin: 'رابط LinkedIn',
    linkedinHint: 'رابط الملف الكامل، مثل https://linkedin.com/in/name.',
  },
  families: {
    eyebrow: 'عائلات المنتجات',
    title: 'عائلات المنتجات',
    newFamily: 'عائلة جديدة',
    createPermission: 'يتطلب إذنًا لإنشاء المحتوى أو تحريره.',
    editPermission: 'يتطلب إذنًا لتحرير المحتوى.',
    colName: 'الاسم',
    colCatalog: 'الكتالوج',
    colOrder: 'الترتيب',
    statusAll: 'جميع الحالات',
    statusDraft: 'مسودة',
    statusInReview: 'قيد المراجعة',
    statusScheduled: 'مجدول',
    statusPublished: 'منشور',
    statusArchived: 'مؤرشف',
    catalogPreview: 'معاينة',
    catalogReady: 'جاهز',
    newTitle: 'عائلة منتجات جديدة',
    untitled: '(بدون عنوان)',
    name: 'الاسم',
    shortName: 'الاسم المختصر',
    tagline: 'العبارة التعريفية',
    slugHint: 'يُنشأ تلقائيًا من الاسم الإنجليزي؛ حرّره للتجاوز.',
    catalogStatus: 'حالة الكتالوج',
    sortOrder: 'ترتيب الفرز',
    summary: 'الملخّص',
    description: 'الوصف',
    heroImage: 'الصورة الرئيسية',
    icon: 'الأيقونة',
    schematic: 'المخطط',
    datasheet: 'ورقة البيانات',
    industries: 'القطاعات',
    industriesHint: 'القطاعات التي تخدمها هذه العائلة. تُستخدم لتصفية القطاعات في الموقع العام وتجميع الصفحة الرئيسية.',
    addIndustry: 'إضافة قطاع',
    remove: 'إزالة',
    noIndustries: 'لا توجد قطاعات مرتبطة بعد.',
    docTitle: 'المحتوى التسويقي',
    highlights: 'أبرز النقاط',
    applications: 'التطبيقات',
    features: 'الميزات',
    standards: 'المعايير',
    tabDetails: 'التفاصيل',
    tabProducts: 'المنتجات',
    tabSeo: 'تحسين محركات البحث',
    tabHistory: 'السجل',
    createdToast: 'تم الإنشاء.',
    savedToast: 'تم الحفظ.',
    publishedToast: 'تم تحديث النشر.',
    unpublishedToast: 'تم إلغاء النشر.',
    unpublishRedirect: 'تُعيد الصفحة العامة الآن التوجيه إلى /products.',
    siteUpdateBody: 'سيتم تحديث الموقع العام قريبًا.',
    deleteTitle: 'حذف عائلة المنتجات هذه؟',
    deleteDescription: 'ستُحذف العائلة نهائيًا وستُعاد صفحتها إلى /products. لا يمكن التراجع عن هذا الإجراء.',
    readinessHeading: 'قائمة الجاهزية',
    readinessReady: 'جاهزة للنشر',
    readinessMissing: 'ما زال مطلوبًا {{count}}',
    readinessHint: 'تحتاج العائلة "الجاهزة" إلى كل هذه العناصر قبل نشرها، وإلا ستظهر صفحتها العامة ناقصة.',
    readyCard: 'محتوى البطاقة',
    readyDetail: 'محتوى صفحة التفاصيل',
    readyBlocked: 'لا يمكن ضبط هذه العائلة كـ"جاهزة" بعد.',
    readyBlockedDetail: 'املأ الحقول المميَّزة ثم احفظ مرة أخرى.',
    docSchemaError: 'تعذّر تحميل مخطط المحتوى. حدّث الصفحة للمحاولة مرة أخرى.',
    productsHeading: 'المنتجات في هذه العائلة',
    productsHint: 'المنتجات التي تظهر تحت هذه العائلة في الموقع العام.',
    addProduct: '+ إضافة منتج',
    noProducts: 'لا توجد منتجات بعد. أضف منتجًا ليظهر تحت هذه العائلة.',
    deleteBlockedTitle: 'تعذّر الحذف: منتجات منشورة',
    deleteBlockedDescription: 'ما زالت هذه العائلة تحتوي على منتجات منشورة ({{slugs}}). ألغِ نشرها أو انقلها أولًا، ثم احذف العائلة.',
  },
  pages: {
    eyebrow: 'الصفحات',
    title: 'الصفحات',
    newPage: 'صفحة جديدة',
    untitled: '(بدون عنوان)',
    allStatuses: 'جميع الحالات',
    statusDraft: 'مسودة',
    statusScheduled: 'مجدولة',
    statusPublished: 'منشورة',
    statusArchived: 'مؤرشفة',
    slugHint: 'يُنشأ تلقائياً من العنوان الإنجليزي؛ عدّله للتجاوز.',
    keyHint: 'مفتاح داخلي فريد (مثل home أو about).',
    tabSections: 'الأقسام',
    tabDetails: 'التفاصيل',
    tabSeo: 'تحسين محركات البحث (SEO)',
    tabHistory: 'السجل',
    editPermissionRequired: 'يتطلب صلاحية لتحرير المحتوى.',
    createdToast: 'تم الإنشاء.',
    savedToast: 'تم الحفظ.',
    publicationUpdatedToast: 'تم تحديث النشر.',
    unpublishedToast: 'تم إلغاء النشر.',
    siteUpdateSoon: 'سيتم تحديث الموقع العام قريباً.',
    deletePageTitle: 'حذف هذه الصفحة',
    deletePageDescription: 'ستُحذف الصفحة وجميع أقسامها. لا يمكن التراجع عن هذا الإجراء.',
    deletePageConfirm: 'حذف الصفحة',
    sectionsCount: '{{count}} أقسام',
    addSection: 'إضافة قسم',
    addSectionTitle: 'إضافة قسم',
    addSectionDescription: 'اختر نوع الكتلة. يُنشأ النموذج من مخطط الكتلة.',
    deleteSectionTitle: 'حذف هذا القسم',
    deleteSectionDescription: 'ستُزال هذه الكتلة من الصفحة. لا يمكن التراجع عن هذا الإجراء.',
    sectionDeletedToast: 'تم حذف القسم.',
    sectionAddedToast: 'تمت إضافة القسم.',
    sectionSavedToast: 'تم حفظ القسم.',
    pageUpdateSoon: 'سيتم تحديث الصفحة العامة قريباً.',
    noSectionsYet: 'لا توجد أقسام بعد',
    noSectionsHint: 'استخدم "إضافة قسم" بالأعلى لوضع أول كتلة في هذه الصفحة.',
    dragToReorder: 'اسحب لإعادة الترتيب',
    visible: 'ظاهر',
    hidden: 'مخفي',
    loadingBlockTypes: 'جارٍ تحميل أنواع الكتل…',
    noBlockTypes: 'لا توجد أنواع كتل مسجّلة.',
    addBlockTitle: 'إضافة {{name}}',
    editBlockTitle: 'تحرير {{name}}',
    anchor: 'المرساة',
    anchorHint: 'مرساة HTML اختيارية للربط المباشر (مثل hero ← ‎#hero).',
    visibleOnPublicPage: 'ظاهر في الصفحة العامة',
    blockNames: {
      hero: 'الواجهة الرئيسية',
      rich_text: 'نص منسّق',
      cta: 'دعوة لاتخاذ إجراء',
      faq: 'الأسئلة الشائعة',
      feature_grid: 'شبكة الميزات',
      stats: 'إحصاءات',
      html_embed: 'تضمين HTML',
      articles_showcase: 'عرض المقالات',
      certifications: 'الاعتمادات',
      contact_form: 'نموذج التواصل',
      department_contacts: 'جهات اتصال الأقسام',
      downloads: 'التنزيلات',
      gallery: 'معرض الصور',
      industries_showcase: 'عرض القطاعات',
      jobs_list: 'قائمة الوظائف',
      locations: 'المواقع',
      logos: 'الشعارات',
      map: 'الخريطة',
      process: 'سير العمل',
      product_family_showcase: 'عرض عائلات المنتجات',
      product_showcase: 'عرض المنتجات',
      projects_showcase: 'عرض المشاريع',
      proof: 'نقاط الإثبات',
      quote_form: 'نموذج طلب عرض سعر',
      services: 'الخدمات',
      split_media: 'وسائط مقسّمة',
      steps: 'الخطوات',
      subsidiaries: 'الشركات التابعة',
      team_grid: 'شبكة الفريق',
      testimonials: 'الشهادات',
    },
    blockDescriptions: {
      hero: 'لافتة الصفحة الرئيسية مع عنوان ودعوة لاتخاذ إجراء.',
      rich_text: 'عنوان مع نص منسّق.',
      cta: 'دعوة تتضمن عنوانًا ونصًّا وأزرارًا.',
      faq: 'قائمة بالأسئلة الشائعة.',
      feature_grid: 'شبكة من الميزات أو النقاط البارزة.',
      stats: 'صف من الأرقام الرئيسية.',
      html_embed: 'مقتطف HTML أو تضمين خام.',
      articles_showcase: 'شريط منسّق من المقالات.',
      certifications: 'شارات الاعتماد والمعايير.',
      contact_form: 'نموذج تواصل أو استفسار مضمّن.',
      department_contacts: 'تفاصيل التوجيه لكل قسم.',
      downloads: 'ملفات وأوراق بيانات قابلة للتنزيل.',
      gallery: 'معرض صور.',
      industries_showcase: 'القطاعات المميّزة التي نخدمها.',
      jobs_list: 'قائمة بالوظائف الشاغرة.',
      locations: 'مواقع المكاتب أو المنشآت.',
      logos: 'شعارات الشركاء أو العملاء.',
      map: 'خريطة موقع مضمّنة.',
      process: 'عملية خطوة بخطوة.',
      product_family_showcase: 'عائلات المنتجات المميّزة.',
      product_showcase: 'المنتجات المميّزة.',
      projects_showcase: 'المشاريع المميّزة.',
      proof: 'إحصاءات ومؤشرات مصداقية رئيسية.',
      quote_form: 'نموذج طلب عرض سعر.',
      services: 'نظرة عامة على الخدمات.',
      split_media: 'نص بجانب صورة أو فيديو.',
      steps: 'قائمة مرتّبة من الخطوات.',
      subsidiaries: 'الشركات التابعة للمجموعة.',
      team_grid: 'ملفات أعضاء الفريق.',
      testimonials: 'شهادات العملاء.',
    },
  },
  leads: {
    unknownType: 'نوع عميل محتمل غير معروف.',
    allStatuses: 'كل الحالات',
    allAssignees: 'كل المسؤولين',
    assignee: 'المسؤول',
    assignedToLabel: 'مُسند إلى',
    assignedTo: 'مُسند إلى {{name}}',
    createdAt: 'أُنشئ {{date}}',
    from: 'من',
    to: 'إلى',
    newOnly: 'الجديدة فقط',
    spam: 'غير مرغوب',
    showingSpam: 'عرض السجلات المصنفة كغير مرغوبة.',
    exportCsv: 'تصدير CSV',
    exportTruncatedTitle: 'اقتُطعت النتائج، يرجى تحسين عوامل التصفية.',
    exportTruncatedBody: 'التصدير محدود بحد أقصى {{count}} صف.',
    readPermissionReason: 'يتطلب صلاحية قراءة العملاء المحتملين.',
    managePermissionReason: 'يتطلب صلاحية إدارة العملاء المحتملين.',
    confirmedPage: 'مؤكَّد (الصفحة) {{count}}',
    pendingPage: 'قيد الانتظار (الصفحة) {{count}}',
    colName: 'الاسم',
    colEmail: 'البريد الإلكتروني',
    colCompany: 'الشركة',
    colLocale: 'اللغة',
    colRequest: 'الطلب',
    estimate: {
      heading: 'التقدير من صفحة الأسعار',
      package: 'الباقة',
      from: 'من',
      care: 'خطة رعاية شهرية',
      perMonth: 'شهرياً',
      custom: 'النطاق يتجاوز حد الباقة',
      pages_one: 'صفحة واحدة',
      pages_other: 'الصفحات: {{count}}',
      bilingual: 'عربي + إنجليزي',
      integrations_one: 'تكامل واحد',
      integrations_other: 'التكاملات: {{count}}',
      unpriced: {
        unknown_package: 'غير مسعّر: الباقة لم تعد منشورة',
        unavailable: 'غير مسعّر: بطاقة الأسعار غير متاحة',
      },
      line: {
        base: 'سعر الباقة',
        pages: 'صفحات إضافية',
        bilingual: 'لغة ثانية',
        integration: 'التكاملات',
        mobile_app: 'تطبيق جوال',
        inherited_code: 'كود كتبه فريق آخر',
        live_replacement: 'استبدال موقع قائم',
      },
    },
    source: {
      heading: 'المصدر',
      label: 'المصدر',
      all: 'كل المصادر',
      pageNote: 'يُطبَّق فلتر المصدر على هذه الصفحة فقط: {{shown}} من {{total}}.',
      channel: {
        linkedin: 'LinkedIn',
        google: 'Google',
        meta: 'Meta',
        chatgpt: 'ChatGPT',
        direct: 'مباشر',
        referral: 'إحالة',
      },
      filter: {
        linkedin: 'LinkedIn',
        google: 'Google',
        meta: 'Meta',
        chatgpt: 'ChatGPT',
        direct: 'مباشر',
        referral: 'مواقع الإحالة',
        other: 'حملات أخرى',
        none: 'غير مسجَّل',
      },
      fields: {
        utmSource: 'مصدر UTM',
        utmMedium: 'وسيط UTM',
        utmCampaign: 'حملة UTM',
        utmContent: 'محتوى UTM',
        utmTerm: 'مصطلح UTM',
        liFatId: 'معرّف نقرة LinkedIn',
        gclid: 'معرّف نقرة Google',
        fbclid: 'معرّف نقرة Meta',
        landingPath: 'صفحة الوصول',
        referrer: 'الموقع المُحيل',
        userAgent: 'متصفح الزائر',
      },
    },
    kind: {
      label: 'النوع',
      all: 'المكالمات والرسائل',
      call: 'مكالمة',
      message: 'رسالة',
    },
    call: {
      heading: 'طلب مكالمة',
      channel: { whatsapp: 'واتساب', video: 'مكالمة فيديو', phone: 'مكالمة هاتفية' },
      openWhatsApp: 'فتح محادثة واتساب',
      dial: 'اتصل الآن',
      noWindows: 'لم تُسجَّل أوقات مفضّلة.',
      visitorTime: '({{time}} بتوقيت الزائر)',
      zoneNote: 'الأوقات المفضّلة بالترتيب، بتوقيت {{zone}}. ردّ لتأكيد أحدها.',
      visitorZone: 'الزائر في {{zone}}.',
    },
    colCv: 'السيرة الذاتية',
    cvYes: 'سيرة ذاتية ✓',
    cvNo: 'بلا سيرة ذاتية',
    leadDetail: 'تفاصيل العميل المحتمل',
    leadUpdated: 'تم تحديث العميل المحتمل.',
    recordErased: 'تم محو السجل نهائيًا.',
    unassigned: 'غير مُسند',
    yes: 'نعم',
    no: 'لا',
    attachment: 'المرفق',
    file: 'ملف',
    metadataOnly: 'البيانات الوصفية فقط. لا يوجد تنزيل مباشر في هذا الإصدار.',
    manage: 'الإدارة',
    internalNotes: 'ملاحظات داخلية',
    notesReplaceHint: 'يؤدي الحفظ إلى استبدال الملاحظات الحالية.',
    saveChanges: 'حفظ التغييرات',
    dangerZone: 'منطقة الخطر',
    erasureDescription:
      'يؤدي المحو وفق نظام حماية البيانات الشخصية (PDPL) إلى حذف هذا السجل وجميع بياناته الشخصية نهائيًا. هذا الإجراء لا يمكن التراجع عنه ويختلف عن حالتي الأرشفة أو غير المرغوب.',
    erasePermanently: 'محو نهائي',
    confirmEraseTitle: 'محو هذا السجل نهائيًا؟',
    confirmEraseDescription:
      'يؤدي هذا إلى حذف السجل وبياناته الشخصية نهائيًا (محو وفق نظام PDPL). لا يمكن التراجع عنه.',
    cv: 'السيرة الذاتية',
    cvRestricted: 'أصل مقيّد. يتم إنشاء رابط تنزيل جديد في كل مرة.',
    openCv: 'فتح السيرة الذاتية',
    noCvUrl: 'لا يتوفر رابط تنزيل لهذه السيرة الذاتية.',
    fields: {
      fullName: 'الاسم',
      email: 'البريد الإلكتروني',
      phone: 'الهاتف',
      company: 'الشركة',
      inquiryType: 'نوع الاستفسار',
      subject: 'الموضوع',
      country: 'الدولة',
      region: 'المنطقة',
      industry: 'القطاع',
      projectLocation: 'موقع المشروع',
      budget: 'الميزانية',
      productFamily: 'عائلة المنتج',
      application: 'التطبيق',
      routedTo: 'موجّه إلى',
      message: 'الرسالة',
      pdplConsent: 'موافقة نظام حماية البيانات',
      productId: 'معرّف المنتج',
      familyId: 'معرّف العائلة',
      quantity: 'الكمية',
      requirements: 'المتطلبات',
      consent: 'الموافقة',
      jobPostingId: 'معرّف إعلان الوظيفة',
      portfolio: 'معرض الأعمال',
      linkedin: 'لينكدإن',
      coverLetter: 'خطاب التقديم',
      status: 'الحالة',
      confirmedAt: 'تاريخ التأكيد',
      unsubscribedAt: 'تاريخ إلغاء الاشتراك',
      locale: 'اللغة',
    },
  },
  leadStatus: {
    new: 'جديد',
    in_progress: 'قيد المعالجة',
    reviewing: 'قيد المراجعة',
    shortlisted: 'في القائمة المختصرة',
    responded: 'تم الرد',
    hired: 'تم التوظيف',
    rejected: 'مرفوض',
    closed: 'مغلق',
    spam: 'غير مرغوب',
    archived: 'مؤرشف',
    pending_confirmation: 'بانتظار التأكيد',
    confirmed: 'مؤكَّد',
    unsubscribed: 'أُلغي الاشتراك',
  },
  media: {
    eyebrow: 'الوسائط',
    libraryTitle: 'مكتبة الوسائط',
    kind: 'النوع',
    kindAll: 'جميع الأنواع',
    kindImages: 'الصور',
    kindSvg: 'SVG',
    kindPdf: 'PDF',
    kindDocuments: 'المستندات',
    kindVideo: 'الفيديو',
    searchPlaceholder: 'اسم الملف أو النص البديل أو الوسوم…',
    size: 'الحجم',
    dimensions: 'الأبعاد',
    uploaded: 'تاريخ الرفع',
    checksum: 'المجموع الاختباري',
    altText: 'النص البديل',
    caption: 'وصف توضيحي',
    credit: 'نسبة المصدر',
    folder: 'المجلد',
    tagsLabel: 'الوسوم (مفصولة بفواصل)',
    restrictedAsset: 'أصل مقيّد',
    restrictedHint:
      'تستخدم الأصول المقيّدة روابط موقّعة مسبقًا قصيرة الأجل ولا يتم تخزينها مؤقتًا أبدًا.',
    tabDetails: 'التفاصيل',
    tabUsages: 'الاستخدامات',
    cannotDeleteInUse: 'تعذّر الحذف: لا يزال هذا الأصل قيد الاستخدام.',
    removeOrSwapRefs: 'أزل هذه المراجع أو استبدلها، ثم أعد المحاولة.',
    deleteAssetTitle: 'حذف أصل الوسائط',
    deleteAssetDescription:
      'يُمنع الحذف إذا كان الأصل مُشارًا إليه في أي مكان. ستُعرض أي مراجع مانعة للحذف.',
    notReferencedSafe: 'هذا الأصل غير مُشار إليه في أي مكان. يمكن حذفه بأمان.',
    savedToast: 'تم الحفظ.',
    deletedToast: 'تم الحذف.',
    chooseMedia: 'اختيار وسائط',
    uploadedToast: 'تم الرفع.',
    uploadedToastDetail: 'الأصل جاهز للاستخدام.',
    unsupportedType: 'نوع ملف غير مدعوم: ‎.{{ext}}',
    exceedsLimit: 'يتجاوز الملف الحد الأقصى البالغ {{limit}}.',
    unsafeSvgTitle: 'تعذّر تنظيف ملف SVG هذا بأمان.',
    unsafeSvgDetail: 'يحتوي على محتوى نشط (نصوص برمجية أو معالجات أحداث) لا يمكن إزالته. أعد تصديره كمتجه بسيط أو استخدم صورة PNG.',
    dragFileHere: 'اسحب ملفًا إلى هنا، أو',
    chooseFile: 'اختيار ملف',
    acceptedHint: 'صور، SVG، PDF، DOC، فيديو · بحد أقصى {{limit}}',
    altTextEnglish: 'النص البديل (الإنجليزية)',
    altTextRequiredHint: 'مطلوب قبل أن يمكن الإشارة إلى الصورة.',
    upload: 'رفع',
  },
  settings: {
    eyebrow: 'الإعدادات',
    pageTitle: 'إعدادات الموقع والواجهة',
    forbidden: 'تتم إدارة إعدادات الموقع من قبل المسؤولين.',
    nav: {
      settings: 'الإعدادات',
      strings: 'نصوص الواجهة',
      navigation: 'التنقل',
      redirects: 'إعادة التوجيه',
      directory: 'دليل جهات الاتصال',
      countries: 'الدول',
      pageCopy: 'محتوى الصفحات',
    },
    general: {
      savedTitle: 'تم حفظ الإعدادات.',
      savedDetail: 'سيتم تحديث الموقع العام قريبًا.',
      localesHeading: 'اللغات',
      defaultLocale: 'اللغة الافتراضية',
      enabledLocales: 'اللغات المفعّلة',
      localeEn: 'الإنجليزية (en)',
      localeAr: 'العربية (ar)',
      requireAr: 'اشتراط الترجمة العربية عند النشر',
      requireArHint: 'منع نشر المحتوى الذي تنقصه الترجمة العربية.',
      maintenanceHeading: 'وضع الصيانة',
      maintenanceToggle: 'تفعيل وضع الصيانة على الموقع العام',
      maintenanceHint:
        'يستبدل جميع صفحات الموقع العام بإشعار ودّي بأن الموقع «قيد الصيانة» حتى لا يرى الزوار محتوى غير مكتمل أو تجريبي. يواصل المحررون عملهم في لوحة التحكم، ويسري التغيير خلال دقيقة.',
      brandIdentityHeading: 'الهوية اللفظية',
      brandIdentityDescription:
        'العلامة اللفظية والعبارة التعريفية والرابط الأساسي التي يعرضها الموقع العام في واجهته.',
      wordmark: 'العلامة اللفظية',
      wordmarkHint: 'العلامة اللفظية للموقع، مثل فاراديف.',
      wordmarkAr: 'العلامة اللفظية (العربية)',
      wordmarkArHint: 'العلامة اللفظية بالخط العربي المعروضة على ‏/ar.',
      tagline: 'العبارة التعريفية',
      taglineHint: 'السطر القصير أسفل العلامة اللفظية — صوت الهامش الإنساني.',
      siteUrl: 'رابط الموقع',
      siteUrlHint: 'الرابط العام الأساسي، مثل https://pharadev.com.',
      brandHeading: 'أصول الهوية البصرية',
      brandDescription:
        'معرّفات أصول الوسائط الخاصة بواجهة الموقع العام. اتركها فارغة لاستخدام إعداد القالب الافتراضي.',
      logoAssetId: 'معرّف أصل الشعار',
      faviconAssetId: 'معرّف أصل أيقونة الموقع',
      ogImageAssetId: 'معرّف أصل صورة المشاركة الافتراضية',
      headScriptsHeading: 'نصوص الترويسة البرمجية',
      headScriptsWarning:
        'تنبيه: يُدرَج هذا الكود حرفيًا في ترويسة كل صفحة عامة. قد يؤدي الكود غير الصالح أو الضار إلى تعطيل الموقع المباشر أو الإضرار به. الصق فقط مقتطفات التحليلات أو التحقق الموثوقة.',
      headScriptsLabel: 'الكود المُدرَج في ترويسة الموقع العام',
      saveButton: 'حفظ الإعدادات',
    },
    messaging: {
      heading: 'قنوات المراسلة',
      description:
        'تطبيقات المحادثة التي يعرضها الموقع العام بجانب واتساب (أعلى الصفحة الرئيسية وصفحة التواصل). رقم واتساب هو الهاتف الثانوي في دليل التواصل.',
      telegram: 'اسم مستخدم تيليجرام',
      telegramHint:
        'المعرّف الذي يراسله الزوار، مثل pharadev للرابط t.me/pharadev. يمكن أيضًا لصق ‎@pharadev أو رابط t.me. اتركه فارغًا لإخفاء تيليجرام.',
      telegramInvalid:
        'استخدم اسم مستخدم تيليجرام: من ٥ إلى ٣٢ حرفًا لاتينيًا أو رقمًا أو شرطة سفلية، ويبدأ بحرف.',
    },
    social: {
      heading: 'روابط التواصل الاجتماعي',
      description:
        'الحسابات المرتبطة في تذييل الموقع والمُدرجة كحسابات المؤسسة لمحركات البحث. رابط واحد لكل منصة.',
      platform: 'المنصة',
      url: 'رابط الحساب',
      urlPlaceholder: 'https://www.linkedin.com/company/…',
      add: 'إضافة رابط تواصل',
      remove: 'حذف الرابط {{n}}',
      moveUp: 'نقل الرابط {{n}} لأعلى',
      moveDown: 'نقل الرابط {{n}} لأسفل',
      rowLabel: 'رابط التواصل {{n}}',
      empty: 'لا توجد روابط تواصل بعد. لن يعرض التذييل أي رابط حتى تضيف واحدًا.',
      errPlatformRequired: 'اختر المنصة.',
      errPlatformDuplicate: 'هذه المنصة مُدرجة بالفعل. أبقِ رابطًا واحدًا لكل منصة.',
      errUrlRequired: 'أدخل رابط الحساب.',
      errUrlInvalid: 'أدخل رابطًا كاملًا، مثل https://www.linkedin.com/company/pharadev.',
      errUrlHttps: 'استخدم رابطًا آمنًا يبدأ بـ https://.',
      fixErrors: 'صحّح روابط التواصل المُعلَّمة قبل الحفظ.',
      platforms: {
        linkedin: 'لينكدإن',
        x: 'إكس (تويتر)',
        facebook: 'فيسبوك',
        instagram: 'إنستغرام',
        youtube: 'يوتيوب',
        github: 'جيت هب',
        tiktok: 'تيك توك',
      },
    },
    navigation: {
      menuHeader: 'الترويسة',
      menuFooter: 'التذييل',
      menuMobile: 'الجوال',
      menuLegal: 'القانوني',
      linkInternal: 'داخلي (مسار)',
      linkExternal: 'خارجي (رابط)',
      savedTitle: 'تم حفظ التنقل.',
      savedDetail: 'سيتم تحديث الموقع العام قريبًا.',
      itemDeleted: 'تم حذف العنصر.',
      errLabelRequired: 'التسمية الإنجليزية مطلوبة.',
      errSlugRequired: 'مسار الوجهة مطلوب للروابط الداخلية.',
      errUrlRequired: 'الرابط مطلوب للروابط الخارجية.',
      menuLabel: 'القائمة',
      newItem: 'عنصر جديد',
      deleteChildrenNote: 'حذف عنصر يؤدي أيضًا إلى إزالة جميع عناصره الفرعية.',
      moveUp: 'تحريك لأعلى',
      moveDown: 'تحريك لأسفل',
      untitled: '(بدون عنوان)',
      childTag: 'فرعي',
      hiddenTag: 'مخفي',
      editItem: 'تعديل عنصر التنقل',
      newItemTitle: 'عنصر تنقل جديد',
      fieldLabel: 'التسمية',
      linkType: 'نوع الرابط',
      targetSlug: 'مسار الوجهة',
      targetSlugHint: 'المسار على الموقع العام، مثل ‏/about.',
      url: 'الرابط',
      urlHint: 'رابط خارجي كامل، مثل ‏https://example.com.',
      openInNewTab: 'فتح في علامة تبويب جديدة',
      visible: 'ظاهر',
      deleteTitle: 'حذف عنصر التنقل؟',
      deleteDescription: 'سيؤدي ذلك أيضًا إلى إزالة أي عناصر فرعية تحته.',
    },
    contact: {
      savedTitle: 'تم حفظ جهة الاتصال.',
      savedDetail: 'سيتم تحديث الموقع العام قريبًا.',
      deleted: 'تم حذف جهة الاتصال.',
      errKeyRequired: 'المفتاح مطلوب.',
      errLabelRequired: 'التسمية الإنجليزية مطلوبة.',
      errEmailRequired: 'البريد الإلكتروني مطلوب.',
      colLabel: 'التسمية',
      colEmail: 'البريد الإلكتروني',
      colPhone: 'الهاتف',
      colVisible: 'ظاهر',
      colOrder: 'الترتيب',
      visibleTag: 'ظاهر',
      hiddenTag: 'مخفي',
      newContact: 'جهة اتصال جديدة',
      editContact: 'تعديل جهة الاتصال',
      fieldLabel: 'التسمية',
      email: 'البريد الإلكتروني',
      phone: 'الهاتف',
      sla: 'اتفاقية مستوى الخدمة',
      slaHint: 'التزام بزمن الاستجابة يُعرَض للزوار، مثل خلال يومي عمل.',
      sortOrder: 'ترتيب الفرز',
      visible: 'ظاهر',
      deleteTitle: 'حذف جهة الاتصال؟',
      deleteDescription: 'إزالة "{{key}}" من الدليل.',
    },
    countries: {
      savedTitle: 'تم حفظ الدولة.',
      savedDetail: 'سيتم تحديث الموقع العام قريبًا.',
      defaultUpdatedTitle: 'تم تحديث الدولة الافتراضية.',
      deleted: 'تم حذف الدولة.',
      errCode: 'استخدم رمز دولة ISO من حرفين.',
      colCode: 'الرمز',
      colDefault: 'الافتراضية',
      colOrder: 'الترتيب',
      defaultTag: 'افتراضية',
      setDefault: 'تعيين كافتراضية',
      newCountry: 'دولة جديدة',
      editCountry: 'تعديل الدولة',
      isoCode: 'رمز ISO',
      isoCodeHint: 'رمز ISO 3166-1 من حرفين، مثل SA.',
      sortOrder: 'ترتيب الفرز',
      setAsDefault: 'التعيين كافتراضية',
      setAsDefaultHint: 'يجعل هذه الدولة الافتراضية الوحيدة.',
      deleteTitle: 'حذف الدولة؟',
      deleteDescription: 'إزالة "{{code}}" من السجل.',
    },
    redirects: {
      status301: '301 نُقل بشكل دائم',
      status302: '302 موجود',
      status307: '307 مؤقت',
      status308: '308 دائم',
      savedTitle: 'تم حفظ إعادة التوجيه.',
      savedDetail: 'سيتم تحديث الموقع العام قريبًا.',
      deleted: 'تم حذف إعادة التوجيه.',
      errFromPath: 'يجب أن يبدأ المسار المصدر بـ "/".',
      errToRequired: 'الوجهة مطلوبة.',
      errToDiffer: 'يجب أن تختلف الوجهة عن المصدر.',
      errStatus: 'اختر حالة إعادة توجيه صالحة.',
      colFrom: 'من',
      colTo: 'إلى',
      colActive: 'نشط',
      colHits: 'الزيارات',
      activeTag: 'نشط',
      inactiveTag: 'غير نشط',
      newRedirect: 'إعادة توجيه جديدة',
      editRedirect: 'تعديل إعادة التوجيه',
      dialogDescription:
        'يتم الإدراج أو التحديث حسب المسار المصدر. تعديل المسار المصدر لإعادة توجيه قائمة يُنشئ مدخلًا جديدًا.',
      fromPath: 'المسار المصدر',
      fromPathHint: 'يجب أن يبدأ بشرطة مائلة، مثل ‏/old-page.',
      toPath: 'المسار الوجهة',
      toPathHint: 'مسار الوجهة أو رابط كامل.',
      active: 'نشط',
      deleteTitle: 'حذف إعادة التوجيه؟',
      deleteDescription: 'إزالة إعادة التوجيه من {{from}}.',
    },
    pageCopy: {
      savedTitle: 'تم الحفظ.',
      savedDetail: 'سيتم تحديث الموقع العام قريبًا.',
      selectPrompt: 'اختر نطاقًا لتعديل محتواه.',
      searchPlaceholder: 'تصفية النطاقات…',
      updatedAt: 'حُدّث {{time}}',
      // محرر المحتوى
      notObject: 'يجب أن يكون المستند كائن JSON.',
      emptyGroup: 'لا توجد حقول.',
      emptyList: 'لا توجد عناصر.',
      itemLabel: 'العنصر {{index}}',
      booleanLabel: 'مُفعّل',
      emptyTextPlaceholder: 'أدخل النص…',
      unsaved: 'تغييرات غير محفوظة',
      allSaved: 'تم حفظ جميع التغييرات',
      // تغطية العربية
      arabicComplete: 'اكتملت الترجمة العربية',
      arabicCompleteHintReady: 'جميع الحقول تحتوي على نص عربي.',
      arabicCompleteHintPending: 'لا يزال {{count}} حقل/حقول بدون عربية.',
      arCoverage: 'تغطية العربية',
      coverageCount: '{{translated}} / {{total}} مُترجَم',
      noFields: 'لا توجد حقول قابلة للترجمة',
      // الاستخدامات (فهرس عكسي ← الصفحات المستهلِكة)
      usagesHeading: 'يظهر في',
      usagesLoading: 'جارٍ التحقق من مواضع ظهور هذا المحتوى…',
      usedByCount: '{{count}} صفحة',
      unused: 'غير مُستخدَم',
      unusedHint: 'لا توجد صفحة تشير إلى هذا النطاق بعد.',
      viaNamespaces: 'مشترك',
      viaCta: 'دعوة لإجراء',
    },
    strings: {
      savedTitle: 'تم حفظ النص.',
      savedDetail: 'سيتم تحديث الموقع العام قريبًا.',
      deleted: 'تم حذف النص.',
      errNamespaceRequired: 'النطاق مطلوب.',
      errKeyRequired: 'المفتاح مطلوب.',
      errValueRequired: 'القيمة الإنجليزية مطلوبة.',
      colNamespace: 'النطاق',
      missingAr: 'العربية ناقصة',
      newString: 'نص جديد',
      editString: 'تعديل النص',
      namespace: 'النطاق',
      value: 'القيمة',
      deleteTitle: 'حذف النص؟',
      deleteDescription: 'إزالة "{{id}}" من واجهة الموقع.',
    },
  },
  users: {
    eyebrow: 'الإدارة',
    title: 'المستخدمون',
    newUser: 'مستخدم جديد',
    forbidden: 'تحتاج إلى صلاحية إدارة المستخدمين لعرض هذه المنطقة.',
    sessionNote: 'تؤدي إعادة تعيين كلمة المرور أو إلغاء تنشيط المستخدم إلى إبطال جلساته النشطة فورًا.',
    columns: {
      email: 'البريد الإلكتروني',
      name: 'الاسم',
      role: 'الدور',
      locale: 'اللغة',
      status: 'الحالة',
      lastLogin: 'آخر تسجيل دخول',
      mfa: 'المصادقة الثنائية',
    },
    status: {
      active: 'نشط',
      inactive: 'غير نشط',
    },
    mfa: {
      enabled: 'مفعّلة',
    },
    serviceAccount: 'حساب خدمي',
    serviceAccountNote:
      'هذا حساب خدمي: جهة آلية تحمل دور رمز الـ API وسجل تدقيقه. لا كلمة مرور له ولا يمكنه تسجيل الدخول. لتغيير صلاحياته، أبطِل رمزه أو أصدر رمزًا جديدًا من صفحة رموز الـ API.',
    roles: {
      admin: 'مسؤول',
      editor: 'محرّر',
      author: 'كاتب',
      translator: 'مترجم',
      sales: 'مبيعات',
      viewer: 'مشاهد',
    },
    locales: {
      en: 'الإنجليزية',
      ar: 'العربية',
    },
    fields: {
      email: 'البريد الإلكتروني',
      name: 'الاسم',
      role: 'الدور',
      locale: 'اللغة',
      active: 'نشط',
      initialPassword: 'كلمة المرور الأولية',
      resetPassword: 'إعادة تعيين كلمة المرور',
      resetPasswordPlaceholder: 'اتركه فارغًا للإبقاء على الحالية',
    },
    hints: {
      minChars: 'عشرة أحرف على الأقل.',
      deactivate: 'يؤدي إلغاء التنشيط إلى إبطال جلسات هذا المستخدم.',
      resetPassword: 'عشرة أحرف على الأقل. تؤدي إعادة التعيين إلى إبطال جلسات هذا المستخدم.',
    },
    create: {
      title: 'مستخدم جديد',
      description: 'أنشئ مستخدمًا إداريًا. يمكنه تسجيل الدخول باستخدام كلمة المرور الأولية التي تحددها هنا.',
      submit: 'إنشاء المستخدم',
    },
    edit: {
      title: 'تعديل {{name}}',
      save: 'حفظ التغييرات',
    },
    delete: {
      title: 'حذف {{name}}؟',
      description:
        'يؤدي هذا إلى حذف {{email}} حذفًا مبدئيًا وإبطال جلساته النشطة. يمنع الخادم حذف آخر مسؤول نشط. لا يمكن التراجع عن هذا الإجراء من هنا.',
      confirm: 'حذف المستخدم',
    },
    toasts: {
      created: 'تم إنشاء المستخدم {{email}}.',
      updated: 'تم تحديث المستخدم {{email}}.',
      deleted: 'تم حذف المستخدم {{email}}. تم إبطال جلساته.',
    },
    errors: {
      emailInUse: 'عنوان البريد الإلكتروني هذا مستخدم بالفعل.',
      lastAdmin: 'لا يمكن تخفيض رتبة آخر مسؤول نشط أو تعطيله.',
    },
  },
  apiTokens: {
    eyebrow: 'الإدارة',
    title: 'رموز الـ API',
    newToken: 'رمز جديد',
    forbidden: 'تحتاج إلى صلاحية إدارة المستخدمين للتحكم في رموز الـ API.',
    intro:
      'تتيح رموز الـ API لعميل آلي — موصّل الذكاء الاصطناعي أو مهمة تكامل مستمر — الكتابة في نظام إدارة المحتوى عبر الصلاحيات والتحقق وسجل التدقيق نفسها التي يستخدمها الإنسان. كل رمز يتبع حسابًا خدميًا، ويمكن تضييقه أكثر، ويمكن إبطاله فورًا.',
    allCollections: 'كل المجموعات',
    neverExpires: 'لا تنتهي',
    neverUsed: 'لم يُستخدم',
    columns: {
      name: 'الرمز',
      account: 'الحساب الخدمي',
      grants: 'ما يستطيع فعله',
      collections: 'ما يستطيع الكتابة فيه',
      lastUsed: 'آخر استخدام',
      expires: 'تنتهي',
      status: 'الحالة',
    },
    status: {
      active: 'نشط',
      expired: 'منتهٍ',
      revoked: 'مُبطَل',
    },
    empty: {
      eyebrow: 'لا توجد رموز بعد',
      title: 'امنح الوكيل مدخلًا آمنًا',
      description:
        'يتيح رمز الموصّل لوكيل ذكاء اصطناعي إضافة مشاريع لأعمالنا ورفع الصور وكتابة النص العربي — بصفته جهة مُسمّاة يمكنك مراقبتها وإيقافها. وهو ليس كلمة مرور مشتركة: فهو يتبع حسابًا خدميًا لا يمكنه تسجيل الدخول إلى هذه اللوحة أبدًا.',
      point1: 'كل ما ينشئه الوكيل يبقى مسودة. النشر يظل قرارًا بشريًا.',
      point2: 'كل عملية كتابة تظهر في سجل التدقيق منسوبة إلى الحساب وإلى الرمز نفسه.',
      point3: 'إبطال الرمز يسري على الطلب التالي مباشرة.',
    },
    fields: {
      name: 'اسم الرمز',
      namePlaceholder: 'كلود — وكيل الأعمال (الحاسوب المحمول)',
      account: 'الحساب الخدمي',
      newAccount: 'إنشاء حساب خدمي جديد',
      accountName: 'اسم الحساب',
      accountNamePlaceholder: 'وكيل الأعمال',
      role: 'الدور',
      scopes: 'الصلاحيات',
      collections: 'المجموعات المسموح بالكتابة فيها',
      expiry: 'ينتهي بعد',
    },
    hints: {
      name: 'سمِّه باسم المكان الذي يعمل فيه، لتعرف أيّها تُبطِل.',
      role: 'سقف الصلاحيات. يستطيع «المؤلف» الكتابة والترجمة ورفع الوسائط، لكنه لا ينشر ولا يحذف.',
      scopes:
        'اختياري. عدم اختيار شيء يمنح كل ما يسمح به الدور؛ واختيار بعضها يضيّقه أكثر. لا يمكن للرمز أن يتجاوز دوره أبدًا.',
      scopesEmpty: 'لم يُحدَّد شيء: سيحصل هذا الرمز على كل ما يسمح به الدور.',
      collections:
        'اختياري. عدم اختيار شيء يسمح بالكتابة في كل المجموعات. القراءة غير مقيّدة، ليتمكن الوكيل من حل الروابط بين المجموعات.',
      collectionsEmpty: 'لم يُحدَّد شيء: يستطيع هذا الرمز الكتابة في كل المجموعات.',
      neverExpiresWarning:
        'الرمز الذي لا ينتهي يجب إبطاله يدويًا. يُفضَّل تحديد مدة وتدويره.',
    },
    expiry: {
      days: '{{count}} يومًا',
      never: 'أبدًا (غير مُستحسَن)',
    },
    create: {
      title: 'رمز API جديد',
      description: 'يُعرض السر مرة واحدة فقط بعد الإنشاء مباشرة، ولا يمكن استرجاعه بعدها.',
      submit: 'إنشاء الرمز',
    },
    secret: {
      title: 'انسخ هذا الرمز الآن',
      description: 'هذه هي المرة الوحيدة التي يُعرض فيها سر «{{name}}».',
      warning:
        'يُخزَّن السر مُجزّأً ولا يمكن استرجاعه. إذا أغلقت هذه النافذة دون نسخه فسيلزمك إنشاء رمز جديد.',
      secretLabel: 'سر الرمز',
      setupLabel: 'تسجيل الموصّل',
      setupHelp: 'نفِّذ هذا على الجهاز الذي سيستضيف الموصّل، مع استبدال المسارين بمساراتك.',
      gitWarning: 'لا تُودِع هذا الأمر أو الإعداد الناتج عنه في مستودع: فهو يحتوي على بيانات اعتماد حيّة.',
      copySecret: 'نسخ سر الرمز',
      copyCommand: 'نسخ أمر الإعداد',
      copied: 'تم النسخ',
      done: 'نسختُه',
      confirmClose: {
        title: 'الإغلاق دون نسخ السر؟',
        description: 'لم تنسخ شيئًا بعد. لا يمكن عرض السر مرة أخرى، وسيصبح الرمز غير قابل للاستخدام.',
        confirm: 'إغلاق على أي حال',
      },
    },
    revoke: {
      action: 'إبطال',
      title: 'إبطال {{name}}؟',
      description:
        'سيفشل الطلب التالي بهذا الرمز فورًا. ويبقى كل ما كتبه سابقًا منسوبًا إليه في سجل التدقيق. لا يمكن التراجع عن هذا — أصدِر رمزًا جديدًا بدلًا منه.',
      confirm: 'إبطال الرمز',
    },
    toasts: {
      revoked: 'تم إبطال الرمز {{name}}.',
    },
  },
  audit: {
    eyebrow: 'سجل التدقيق',
    title: 'سجل التدقيق',
    forbidden: 'ليس لديك إذن لعرض سجل التدقيق.',
    colTime: 'الوقت',
    colActor: 'المنفِّذ',
    colAction: 'الإجراء',
    colEntity: 'الكيان',
    colIp: 'عنوان IP',
    filterEntityType: 'نوع الكيان',
    filterEntityId: 'معرّف الكيان',
    filterActorId: 'معرّف المنفِّذ',
    filterApiTokenId: 'معرّف رمز الـ API',
    filterApiTokenHint: 'حصر النتائج في بيانات اعتماد بعينها، لا في الحساب فقط.',
    viaToken: 'عبر رمز',
    filterFrom: 'من',
    filterTo: 'إلى',
    entryTitle: 'سجل التدقيق',
    detailUserAgent: 'وكيل المستخدم',
    detailDiff: 'الفروقات',
  },
  account: {
    eyebrow: 'الحساب',
    title: 'حسابك',
    profile: 'الملف الشخصي',
    name: 'الاسم',
    interfaceLanguage: 'لغة الواجهة',
    saveProfile: 'حفظ الملف الشخصي',
    changePassword: 'تغيير كلمة المرور',
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    profileUpdated: 'تم تحديث الملف الشخصي.',
    passwordChanged: 'تم تغيير كلمة المرور. تم تسجيل خروج جلساتك الأخرى.',
    mfaTitle: 'المصادقة الثنائية',
    mfaEnabledHint: 'المصادقة الثنائية مفعّلة. يتطلب تسجيل الدخول رمزًا من تطبيق المصادقة لديك.',
    mfaSetupHint: 'أضِف رمزًا مؤقتًا يُستخدم لمرة واحدة (TOTP) لطبقة أمان إضافية.',
    beginEnrollment: 'بدء التسجيل',
    qrAlt: 'رمز الاستجابة السريعة للمصادقة الثنائية',
    enterSecret: 'أو أدخل هذا الرمز السري: {{secret}}',
    code6: 'رمز مكوّن من 6 أرقام',
    code6Disable: 'رمز مكوّن من 6 أرقام للتعطيل',
    verifyAndEnable: 'التحقق والتفعيل',
    disableMfa: 'تعطيل المصادقة الثنائية',
    mfaEnabledToast: 'تم تفعيل المصادقة الثنائية.',
    mfaDisabledToast: 'تم تعطيل المصادقة الثنائية.',
    mfaBadge: 'المصادقة الثنائية',
    strengthTooWeak: 'ضعيفة جدًا',
    strengthWeak: 'ضعيفة',
    strengthFair: 'مقبولة',
    strengthGood: 'جيدة',
    strengthStrong: 'قوية',
  },
  search: {
    placeholder: 'ابحث في المحتوى ونصوص الموقع…',
    ariaLabel: 'البحث الشامل',
    searching: 'جارٍ البحث…',
    noResults: 'لا توجد نتائج.',
    entity: {
      page: 'صفحة',
      page_copy: 'محتوى الصفحات',
      family: 'عائلة',
      product_family: 'عائلة',
      industry: 'قطاع',
      project: 'مشروع',
      article: 'مقالة',
      job: 'وظيفة',
      product: 'منتج',
      location: 'موقع',
      subsidiary: 'شركة تابعة',
    },
  },
  preview: {
    dialogTitle: 'معاينة المسودة',
    iframeTitle: 'معاينة',
  },
  revisions: {
    restore: 'استعادة',
    restoredToast: 'تمت الاستعادة كمراجعة جديدة.',
    restoredToastDesc: 'تُركت حالة النشر دون تغيير.',
    restoreDialogTitle: 'استعادة المحتوى كمراجعة جديدة',
    restoreDialogDesc:
      'يؤدي هذا إلى إعادة تطبيق الحقول التحريرية للمراجعة المحددة وإنشاء مراجعة جديدة. تُترك حالة النشر دون تغيير.',
  },
  publish: {
    publishNow: 'نشر الآن',
    reschedule: 'إعادة جدولة',
    scheduleDialogTitle: 'جدولة النشر',
    scheduleDialogDesc: 'يقوم مؤقّت الخادم بالنشر في الوقت المحدد.',
    publishAt: 'نشر في',
  },
  seo: {
    metaTitle: 'عنوان الميتا',
    metaDescription: 'وصف الميتا',
    keywords: 'الكلمات المفتاحية',
    socialImage: 'صورة التواصل الاجتماعي',
    canonicalUrl: 'الرابط الأساسي (Canonical)',
    noIndex: 'إخفاء من محركات البحث (noindex)',
  },
};

export default ar;
